module.exports = __webpack_public_path__ + "img/网站-14.f4281ce0.jpg";